// src/components/Gracias.js
import React from "react";
import { Link } from "react-router-dom";

function Gracias() {
  return (
    <div style={{ margin: "2rem" }}>
      <h1>¡Registro finalizado con éxito!</h1>
      <p>Muchas gracias por usar nuestra aplicación.</p>
      <Link to="/">Ir al inicio</Link>
    </div>
  );
}

export default Gracias;